export enum EmailType {
  Confirmed = 0,
  Updated = 1,
  Cancelled = 2
}
